import { render, staticRenderFns } from "./OferteProductieConfiguratorNou.vue?vue&type=template&id=37353275&scoped=true"
import script from "./OferteProductieConfiguratorNou.vue?vue&type=script&lang=js"
export * from "./OferteProductieConfiguratorNou.vue?vue&type=script&lang=js"
import style0 from "./OferteProductieConfiguratorNou.vue?vue&type=style&index=0&id=37353275&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37353275",
  null
  
)

export default component.exports